import { Box, Typography } from '@locus-taxy/disco-ui';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';

export default function SettingsPage() {
  const { t } = useTranslation();
  return (
    <Box className="flex h-full flex-col items-center justify-center bg-card p-6 text-center">
      <Typography variant="h2">
        {t('dashboard.settingsPage.title', 'Settings')}
      </Typography>
      <Typography variant="h6" color="muted">
        {t(
          'dashboard.settingsPage.description',
          'This is the main application settings page.'
        )}
      </Typography>
      <Typography color="muted" className="max-w-[400px]">
        {t(
          'dashboard.settingsPage.comingSoon',
          'Configurations and user preferences will be managed here in the future.'
        )}
      </Typography>
    </Box>
  );
}
